<template>
    <div v-if="show" class="mask">
        <div class="form-modal file-log-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">修改历史</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>       
            <div class="flex  body  border-box  border-box " style="height: calc(100% - 80px);"  >

                <div class="content flex flex-col padding-m border-box ">
                    <div class="flex flex-center-sp full-width flex-center-cz" style="height: 36px;">
                        <span>历史版本：</span>
                        <Select :data="verData" v-model="selectVer"  @change="verChange" style="width: 300px;"></Select>
                    </div>
                    <vue-custom-scrollbar class="margin-top-m book  full-height full-width scroll border-box padding-l rtfDiv"
                        style="background-color: #fff;"  v-html="selected.content">
                    </vue-custom-scrollbar>
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box bk-color-white ">
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">关闭</div>         
            </div>

        </div>
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import Select from '@/components/select/Select' 
    import {getJsDateTime} from '@/utils/dateUtils'

    export default {
        name:'FileLogModal',
        created() {
        },
        components:{RichText,Select},
        props:{
            open:{},
            logs:{},
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue == true) {
                        console.log("logs====", this.logs);
                        if (this.logs != null && this.logs.length > 0) {
                            this.selected = this.logs[0]
                            this.verData = [];
                            this.logs.forEach(item => {
                                this.verData.push({"text": getJsDateTime(item.createTime), "value": item.id});
                                if (this.selectVer == null)  {
                                    this.selectVer = item.id
                                }                           
                            });                            
                        }  
                    }
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,
                selected:[{
                    content:''
                }],
                selectVer:null,
                verData:[]
            }
        },
        methods:{
            verChange(data) {
                this.selected = this.logs.filter(item=>item.id === data)[0];

            } ,
            close() {
                this.$emit("close")
            },
        }
   }
</script>

<style scoped>

    .rtfDiv >>> img {
        max-width: 100% ;
    }


    .form-modal {
        top:20px;
    }
    .form-modal .body{

        padding-bottom: 0px;

    }
    .file-log-modal {
        width: 1000px;
        height: 820px;
        background-color: #ddd;
    }

    .file-log-modal .content {
        height: 715px;
        width: calc(100% - 50px);
    }
    

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/FileLogModal.vue